<template>
    <div class="sched-app-program-filter" :class="channelColorCSS">
        <i class="material-icons" :class="channelColorCSS">search</i>
        <input type="text" placeholder="Filter..." v-model="filter" autofocus :class="channelColorCSS">
    </div>
</template>

<script>
export default {
  computed: {
    filter: {
      get () {
        return this.$store.state.filter
      },
      set (e) {
        this.$store.commit('setFilter', e)
      }
    },

    channelColorCSS () {
      return `sched-app-${this.$store.state.channel.value}-color`
    }
  }
}
</script>

<style>
.sched-app-program-filter {
    display: flex;
    font-size: 24px;
    color: #aaa;
    padding: 10px 20px;
    background: #fff;
    border-bottom: solid 2px rgba(0,0,0,0.1);
}

.sched-app-program-filter .material-icons {
    font-size: 32px;
}

.sched-app-program-filter input {
    border: none;
    outline: none;
    font-size: inherit;
    background: rgba(0,0,0,0);
}

::placeholder {
    color: inherit
}
</style>
